import { Component, OnInit, Input,  Output, EventEmitter } from '@angular/core';
import {ReportsService} from "../../report-components/reports.service";
import * as _ from "lodash";
import {MatTableDataSource} from "@angular/material/table";


@Component({
  selector: 'app-network-select',
  templateUrl: './network-select.component.html',
  styleUrls: ['./network-select.component.css']
})
export class NetworkSelectComponent implements OnInit {

  /*
  https://docs.angular.lat/guide/inputs-outputs

  parent:
        [] input
        () output


        Parent HTML
        <app-network-select (newItemEventNetwork)= "selectValueNetwork($event)"></app-network-select>

        Parent TypeScript - Place in Compomenent that uses the reusable component
        selectValueNetwork(value) {
           this.network_id = value['network_id'];
           this.network_name = value['network_name'];
          console.log('network_id from parent:',this.network_id)
        }



  */


  @Input() agency_id = '';
  @Input() account_id = '';


  @Output() newItemEventNetwork = new EventEmitter<any>();
  cagad_network_object = [{name: "Facebook", id: 'facebook'},{name: "Googleads", id: 'googleads'}];
  network_id_name_lookup = {'facebook': 'Facebook', 'googleads': 'Googleads'};
  x_body = {}

  constructor(private reportService: ReportsService) { }

  ngOnInit(): void {
    this.cagad_network_object = [{name: "Facebook", id: 'facebook'},{name: "Googleads", id: 'googleads'}]
  } //end ngOnInit



  network_id: string = null;
  selectNetworkEvent(event){
    this.network_id = event.value;
    console.log('network_id from reusable:',this.network_id)
    let temp = {'network_id': this.network_id, 'network_name': this.network_id_name_lookup[this.network_id]}
    this.newItemEventNetwork.emit(temp);
  } //end selectCampaignEvent



}
